import { ReactNode, useEffect, useEffectEvent } from 'react';
import { EmailNavigationAccordion } from '@/features/email-flows/emails/components';
import { useEmailEditorData } from '@/features/email-flows/emails/hooks/useEmailEditorData';
import { useEmailEditorStore } from '@/features/email-flows/emails/stores';

interface EmailEditorLayoutProps {
    children: ReactNode;
    flowId: number;
    emailId?: number;
}

export const EmailEditorLayout = ({ children, flowId, emailId }: EmailEditorLayoutProps) => {
    // Fetch and populate store with email editor data
    const { flowData, isLoading } = useEmailEditorData({
        flowId,
        emailId,
    });

    // Event handler for store reset
    const resetStore = useEmailEditorStore(state => state.reset);
    const handleReset = useEffectEvent(() => {
        resetStore();
    });

    // Reset store on unmount
    useEffect(() => {
        return () => handleReset();
    }, []);

    if (isLoading) {
        return null;
    }

    return (
        <div className='pb-6'>
            {/* Page Header */}
            <p className='text-heading-h2 mb-6'>{flowData?.data?.name || 'Untitled Flow'}</p>

            {/* Main Content: Navigation + Editor */}
            <div className='flex flex-col gap-x-6 max-md:gap-y-6 md:flex-row'>
                {/* Email Navigation */}
                {flowData && <EmailNavigationAccordion flow={flowData} currentEmailId={emailId} />}

                {/* Email Editor Form */}
                <div className='relative flex-1'>{children}</div>
            </div>
        </div>
    );
};
